<script setup lang="ts">
import { formatPriceChange } from '@/lib/money'

/**
 * The uncoloured single-line price move the prices grid uses.
 *
 * Two of these sit side by side in one fixed column, so the form is the narrowest
 * that still reads: the sign carries the direction (the arrow icon it replaced cost
 * 16px per figure and said nothing the sign does not), and one decimal rather than
 * two. The two-decimal arrowed form overflowed the column onto the listings badge
 * beside it.
 *
 * Distinct from `PriceChangeCell.vue`, the coloured form the market cards use.
 */
defineProps<{
    value: number | null | undefined
}>()
</script>

<template>
    <p class="text-xs font-medium text-muted-foreground">
        <span v-if="value" class="text-foreground text-xs font-medium tabular-nums whitespace-nowrap">
            {{ formatPriceChange(value) }}
        </span>

        <span v-else class="text-xs text-muted-foreground">-</span>
    </p>
</template>
